import React from 'react';

const NoMatch = () => {
    return (
        <div>
            <h1>This page is int Pound</h1>
        </div>
    );
};

export default NoMatch;